import request from './request'
import type { TasksMapPanelTab } from './tasksMap'
import { getMockTasksMapMetaResponse, shouldUseTasksMapMock } from './tasksMapMetaMock'

export interface ApiResponse<T = unknown> {
  code: number
  data: T
  msg: string
}

export interface TasksMapMetaTab {
  value: string
  label: string
}

export interface TasksMapMetaData {
  tabs?: TasksMapMetaTab[]
  [key: string]: unknown
}

export interface TasksMapTabView {
  value: TasksMapPanelTab
  label: string
}

export const DEFAULT_TASKS_MAP_TABS: TasksMapTabView[] = [
  { value: 'inspectors', label: 'Inspectors' },
  { value: 'technician', label: 'Technician' },
]

const TAB_VALUE_ALIASES: Record<string, TasksMapPanelTab> = {
  inspector: 'inspectors',
  inspectors: 'inspectors',
  technician: 'technician',
  technicians: 'technician',
}

export function normalizeTasksMapTabValue(value: string): TasksMapPanelTab | null {
  const key = value.trim().toLowerCase()
  return TAB_VALUE_ALIASES[key] ?? null
}

function buildTabViews(raw: TasksMapMetaTab[] | undefined): TasksMapTabView[] {
  if (!Array.isArray(raw) || !raw.length) return [...DEFAULT_TASKS_MAP_TABS]

  const tabs = raw
    .map((entry) => {
      const value = normalizeTasksMapTabValue(String(entry.value ?? ''))
      const label = String(entry.label ?? '').trim()
      if (!value || !label) return null
      return { value, label }
    })
    .filter((item): item is TasksMapTabView => item != null)

  return tabs.length ? tabs : [...DEFAULT_TASKS_MAP_TABS]
}

export interface TasksMapMetaView {
  tabs: TasksMapTabView[]
}

export function mapTasksMapMetaToView(meta: TasksMapMetaData | null | undefined): TasksMapMetaView {
  return {
    tabs: buildTabViews(meta?.tabs),
  }
}

/** POST `/api/admin/tasks-map/meta` */
export async function postTasksMapMeta(): Promise<ApiResponse<TasksMapMetaData>> {
  if (shouldUseTasksMapMock()) {
    return getMockTasksMapMetaResponse() as ApiResponse<TasksMapMetaData>
  }
  return request.post<ApiResponse<TasksMapMetaData>>('/api/admin/tasks-map/meta', {})
}
